
import Footer from "/@src/containers/navs/Footer";

import { appRoot } from "/@src/constants/defaultValues";
import { NavLink } from "reactstrap";
import { useContext, useEffect } from "react";
import { WordPressAppContext } from ".";

const WordPressAppLayout = ({ children }) => {

  useEffect(() => {
    import("./wordpress.css");
  }, []);
  const { page, projectId, slug, apiKey, initialPage, setPage } =
    useContext(WordPressAppContext);

  return (
    <div className="dashboard-wrapper" id="wordpress-app-wrapper">
      <div id="app-container" className="menu-sub-hidden main-hidden sub-hidden">

        <nav className="navbar justify-content-between">
          <div className="d-flex flex-1 navbar-left">

            <NavLink className="nav-item" onClick={() => setPage("dashboard")} active={page === "dashboard"}>Dashboard</NavLink>
            <NavLink className="nav-item"  onClick={() => setPage("manageBilling")} active={page === "manageBilling"}>Billing</NavLink>
            <NavLink className="nav-item" onClick={() => setPage("reports")} active={page === "reports"}>Reports</NavLink>
            <NavLink className="nav-item" onClick={() => setPage("settings")} active={page === "settings"}>Settings</NavLink>
          </div>
          <div>
            <NavLink className="navbar-logo position-relative" to={appRoot}>
              <span className="logo d-none d-xs-block" />
              <span className="logo-mobile d-block d-xs-none" />
            </NavLink>
          </div>
        </nav>
        <main>
          <div className="container">{children}</div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default WordPressAppLayout;
